/**
 * What the inspector reads when the server refuses a filed visit. Axios's own
 * message ("Request failed with status code 409") told Joe nothing twelve
 * times on 11/3 after he tried to re-review a report that had already gone to
 * the client. The server's detail says what happened; a refused revise also
 * says where to go next.
 */
export const HUB_EDIT_HINT =
  'To change it, open the report in EnviroHub, use Edit there, then Send again.';

export function submitRefusalMessage(
  status: number | null | undefined,
  detail: unknown,
  revising: boolean
): string | null {
  if (!status || status < 400 || status >= 500) return null;
  const text = typeof detail === 'string' ? detail.trim() : '';
  if (revising && status === 409) {
    return `${text || 'This report has already been sent to the client and can no longer be revised here.'} ${HUB_EDIT_HINT}`;
  }
  return text || null;
}
